import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCallback, useEffect, useRef, useState } from "react";
import { Collapse } from "react-bootstrap";
import { ColumnDescription } from "react-bootstrap-table-next";
import Swal from "sweetalert2";
import { ListarClassificacaoCobrancaController } from "../../../../../Controllers/Cobranca/ClassificacaoCobranca/ClassificacaoCobrancaController";
import {
    AtualizarResultadoContatoController,
    DeletarResultadoContatoController,
    ListarResultadoContatoController,
} from "../../../../../Controllers/Cobranca/ResultadoContato/ResultadoContatoController";
import { ClassificacaoCobrancaInterface } from "../../../../../Interfaces/Cobranca/ClassificacaoCobranca/ClassificacaoCobrancaInterface";
import { IResultadoContato } from "../../../../../Interfaces/Cobranca/ResultadoContato/ResultadoContatoInterface";
import SpinnerComponent from "../../../../Loding/Spinner";
import Table from "../../../../Table";
import CadastrarEditarResultadoContato from "./CadastrarEditarResultadoContato";
import "./style.css";

function ResultadoContato() {
    const [lstResultadoContato, setLstResultadoContato] = useState(
        [] as Array<IResultadoContato>
    );

    const [editting, setEditting] = useState<IResultadoContato>();
    const lstClassificacaoRef = useRef<ClassificacaoCobrancaInterface[]>();

    useEffect(() => {
        updateListaResultadoContato();
    }, []);

    function updateListaResultadoContato() {
        ListarResultadoContatoController().then((response) => {
            setLstResultadoContato(response);
        });
        setEditting(undefined);
    }

    const ListarClassificacao = useCallback(async () => {
        if (!lstClassificacaoRef.current)
            lstClassificacaoRef.current =
                await ListarClassificacaoCobrancaController();

        return lstClassificacaoRef.current;
    }, []);

    function Edit(toEdit: IResultadoContato) {
        if (
            editting?.ID_CASO_COBRANCA_RESULTADO_CONTATO ===
            toEdit.ID_CASO_COBRANCA_RESULTADO_CONTATO
        )
            setEditting(undefined);
        else if (!editting) {
            setEditting(toEdit);
        } else {
            setEditting(undefined);
            setTimeout(() => {
                setEditting(toEdit);
            }, 500);
        }
    }

    //Tabela
    const columns: Array<ColumnDescription> = [
        {
            dataField: "DS_RESULTADO_CONTATO",
            text: "Resultado Contato",
            formatter: rowResultado,
            sort: true,
        },
        {
            dataField: "DS_CLASSIFICACAO",
            text: "Classificação",
            classes: "hideInMobile",
            headerClasses: "hideInMobile",
            sort: true,
        },
        {
            dataField: "NR_TEMPO_RETORNO_FILA",
            text: "Espera",
            classes: "hideInMobile",
            headerClasses: "hideInMobile",
            formatter: rowTempo,
        },
        {
            dataField: "FL_ATIVO",
            text: "Ativo",
            classes: "hideInMobile",
            headerClasses: "hideInMobile",
            formatter: (c) => <div>{c === true ? "Ativo" : "Desativado"}</div>,
        },
        {
            dataField: "DS_CASO_COBRANCA_CLASSIFICACAO_COBRANCA",
            text: "Classificação de Contrato",
            classes: "hideInMobile",
            headerClasses: "hideInMobile",
        },
        {
            dataField: "ID_CASO_COBRANCA_RESULTADO_CONTATO",
            text: "",
            formatter: rowEditDelete,
            formatExtraData: Edit,
        },
    ];
    function rowResultado(cell: string, row: IResultadoContato) {
        return (
            <div className="rowCapysRC d-flex justify-content-between align-itens-center flex-column">
                <label className="mb-1">{cell}</label>
                <label className="mb-1 showInMobile">
                    Classificado como {row.DS_CLASSIFICACAO}
                </label>
                <label className="mb-1 showInMobile">
                    {rowTempo(row.NR_TEMPO_RETORNO_FILA)} de espera
                </label>
                {row.DS_CASO_COBRANCA_CLASSIFICACAO_COBRANCA && (
                    <label className="mb-1 showInMobile">
                        Atualiza para contrato:{" "}
                        {row.DS_CASO_COBRANCA_CLASSIFICACAO_COBRANCA}
                    </label>
                )}

                <div>
                    <span
                        className={`label btn abel-pill label-inline label-${
                            row.FL_ATIVO ? "success" : "danger"
                        }`}
                        onClick={() => {
                            AtualizarResultadoContatoController({
                                DS_CLASSIFICACAO: row.DS_CLASSIFICACAO,
                                DS_RESULTADO_CONTATO: row.DS_RESULTADO_CONTATO,
                                ID_CASO_COBRANCA_RESULTADO_CONTATO:
                                    row.ID_CASO_COBRANCA_RESULTADO_CONTATO,
                                NR_TEMPO_RETORNO_FILA:
                                    row.NR_TEMPO_RETORNO_FILA,
                                FL_ATIVO: !row.FL_ATIVO,
                            }).then(() => {
                                updateListaResultadoContato();
                            });
                        }}
                    >
                        {row.FL_ATIVO ? "Ativo" : "Desativo"}
                    </span>
                </div>
            </div>
        );
    }
    function rowTempo(cell: number) {
        return <>{cell ? cell : 0} hora(s)</>;
    }
    function rowEditDelete(
        cell: string,
        row: IResultadoContato,
        _: number,
        Edit: (toEdit: IResultadoContato) => void
    ) {
        return (
            <div className="col-12 text-center d-flex g-2">
                <button
                    className="btn  btn-sm btn-outline-primary font-weight-bold"
                    onClick={() => {
                        Edit(row);
                    }}
                >
                    <FontAwesomeIcon icon={faEdit} size="lg" />
                </button>
                <button
                    className="btn  btn-sm btn-outline-danger font-weight-bold"
                    onClick={() => {
                        Swal.fire({
                            title: "Deseja apagar este resultado de contato?",
                            icon: "info",
                            buttonsStyling: false,
                            confirmButtonText:
                                "<i class='la la-check'></i> Sim!",
                            showCancelButton: true,
                            cancelButtonText:
                                "<i class='la la-thumbs-down'></i> Não",
                            customClass: {
                                confirmButton: "btn btn-outline-success",
                                cancelButton: "btn btn-default",
                            },
                        }).then((result) => {
                            if (result.isConfirmed) {
                                DeletarResultadoContatoController(
                                    row.ID_CASO_COBRANCA_RESULTADO_CONTATO
                                ).then(() => {
                                    updateListaResultadoContato();
                                });
                            }
                        });
                    }}
                >
                    <FontAwesomeIcon icon={faTrash} size="lg" />
                </button>
            </div>
        );
    }

    return lstResultadoContato.length ? (
        <>
            <div className="Row1 d-flex flex-columns row">
                <div className="col-12 collapse mb-5" id="collapseForm">
                    <CadastrarEditarResultadoContato
                        then={updateListaResultadoContato}
                        ListarClassificacaoCobranca={ListarClassificacao}
                    />
                </div>

                <div className="col-12 mt-5">
                    <Table
                        keyField="ID_CASO_COBRANCA_RESULTADO_CONTATO"
                        columns={columns}
                        data={lstResultadoContato}
                        sizePerPage={5}
                    />
                </div>
                <Collapse in={!!editting} mountOnEnter unmountOnExit>
                    <div>
                        <CadastrarEditarResultadoContato
                            edit={editting}
                            then={updateListaResultadoContato}
                            ListarClassificacaoCobranca={ListarClassificacao}
                        />
                    </div>
                </Collapse>
            </div>
        </>
    ) : (
        <SpinnerComponent />
    );
}

export default ResultadoContato;
